import { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { fetchSiteRates } from '../services/siteRatesService';
import { getSiteConfigFromData } from '../config/siteConfig';

// Default degrades to Rands-only: any consumer rendered without a provider
// (or before load / after a failed load) gets null configs.
const defaultValue = {
  loading: false,
  error: null,
  getSiteConfig: () => null,
};

const SiteRatesContext = createContext(defaultValue);

export const useSiteRates = () => useContext(SiteRatesContext);

export const SiteRatesProvider = ({ children }) => {
  const [sites, setSites] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchSiteRates()
      .then((data) => {
        if (!cancelled) setSites(data?.sites ?? {});
      })
      .catch((err) => {
        // Degrade to Rands-only rather than surfacing a broken dashboard.
        if (!cancelled) setError(err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const value = {
    loading,
    error,
    getSiteConfig: (siteName) => getSiteConfigFromData(sites, siteName),
  };

  return (
    <SiteRatesContext.Provider value={value}>
      {children}
    </SiteRatesContext.Provider>
  );
};

SiteRatesProvider.propTypes = {
  children: PropTypes.node,
};

export default SiteRatesContext;
